/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ListOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M3.75 12h16.5M3.75 6h16.5M3.75 18h16.5"
})));
// Fill
const ListFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M20.25 11.25H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zm-16.5-4.5h16.5a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0 0 1.5zm16.5 10.5H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
})));
// DuoTone
const ListDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M3.75 12h16.5M3.75 6h16.5M3.75 18h16.5"
})));
/**
  Icon ListIcon in office group
*/
export const ListIcon = createIcon('ListIcon', 'list', 'office', ListOutline, ListFill, ListDuotone, "0 0 24 24");